import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import _get from 'lodash/get';
import useContentfulLocale from 'components/useContentfulLocale';
import { makeSelectAuth, makeSelectAuthModal } from 'containers/Auth/selectors';
import useIsEmailVerified from './useIsEmailVerified';

/**
 * useRequestEmailVerification
 * Calls the email verification endpoint and redirects to /signup/verify
 * Usage: const requestEmailVerification = useRequestEmailVerification();
 *        requestEmailVerification();
 */
export default function useRequestEmailVerification() {
  const auth = useSelector(makeSelectAuth());
  const modal = useSelector(makeSelectAuthModal());
  const history = useHistory();
  const { locale } = useContentfulLocale();
  const dispatch = useDispatch();
  const { needsVerification } = useIsEmailVerified();

  /**
   * @param {string} [redirect] - Optional redirect path to append as query param
   */
  return useCallback(
    async redirect => {
      const token = _get(auth, 'stsTokenManager.accessToken');
      if (!token) return; // Only trigger if token exists
      if (!needsVerification) {
        return;
      }
      if (redirect) {
        history.push(`/signup/verify?redirect=${encodeURIComponent(redirect)}`);
      } else {
        history.push('/signup/verify');
      }
    },
    [auth, history, locale, modal, dispatch, needsVerification],
  );
}
